import { render } from "./PreviewMentorias.vue?vue&type=template&id=45b7f3db"
import script from "./PreviewMentorias.vue?vue&type=script&lang=js"
export * from "./PreviewMentorias.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__